// extracted by mini-css-extract-plugin
export default {"progressBarWrap":"ProgressBar_progressBarWrap__Gw3+w","barValue":"ProgressBar_barValue__AGSwh"};